// src/components/home/BottomSection.jsx
import React from "react";
import LatestNews from "./LatestNews";
import ScrollReveal from "../common/ScrollReveal";

const YouTubeEmbed = ({ videoId }) => {
  if (!videoId) return null;

  return (
    <div className="relative w-full aspect-video bg-black rounded overflow-hidden">
      <iframe
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video"
        className="absolute inset-0 w-full h-full"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
};

const ImageBlock = ({ image, baseUrl = "" }) => {
  if (!image?.url) return null;

  const imageUrl = `${baseUrl}${image.url}`;

  return (
    <div className="w-full aspect-video overflow-hidden rounded">
      <img
        src={imageUrl}
        alt={image.alternativeText || "Image"}
        className="w-full h-full object-cover"
      />
    </div>
  );
};

const BottomSection = ({
  bottomItems = [],
  news = [],
  newsTitle = "Latest News",
  moreNewsBtnText = "More News",
  baseUrl = "",
}) => {
  // Separate YouTube videos and images from bottom items
  const mediaItems = bottomItems.filter(
    (item) => item.youtube_id || item.img
  );
  const fixedMediaItems = mediaItems.slice(0, 4);

  return (
    <section className="py-4 sm:py-6">
      <div className="w-full">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 sm:gap-7 lg:gap-8">
          {/* Latest News Column */}
          <div className="lg:col-span-1 order-2 lg:order-1">
            <LatestNews
              news={news}
              title={newsTitle}
              moreButtonText={moreNewsBtnText}
            />
          </div>

          {/* Media Columns (YouTube / Images) - fixed 2x2 on desktop, stacked on mobile */}
          <div className="lg:col-span-2 order-1 lg:order-2">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4">
              {fixedMediaItems.map((item, index) => (
                <ScrollReveal
                  key={item.id || index}
                  className={`homepage-fade-up-item homepage-fade-up-item--d${(index % 4) + 1}`}
                >
                  <div className="panel-elevated rounded-lg p-2">
                    {item.youtube_id ? (
                      <YouTubeEmbed videoId={item.youtube_id} />
                    ) : item.img ? (
                      <ImageBlock image={item.img} baseUrl={baseUrl} />
                    ) : null}
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BottomSection;
